import React from 'react';
import '../../style/banner.scss';
import Context from '../../tools/context';

const Banner = () => {
  return (
    <div className='bannerWrapper sav'
    dangerouslySetInnerHTML={{
      __html: Context.partner.savBanner,
    }}
    >
    </div>
  );
};

export default Banner;
